module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-companies",
    attrs: {
      "id": "companies"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('div', {
    staticClass: "plan-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-full",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContent(0)
      }
    }
  }, [_vm._v("详情")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('div', {
    staticClass: "plan-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-ghost",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContent(1)
      }
    }
  }, [_vm._v("详情")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('div', {
    staticClass: "plan-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-ghost",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContent(2)
      }
    }
  }, [_vm._v("详情")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('div', {
    staticClass: "plan-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-ghost",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContent(3)
      }
    }
  }, [_vm._v("详情")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('div', {
    staticClass: "plan-box"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-ghost",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContent(4)
      }
    }
  }, [_vm._v("详情")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('div', {
    staticClass: "plan-box"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-ghost",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContent(5)
      }
    }
  }, [_vm._v("详情")])])])])]), _vm._v(" "), _c('new-content'), _vm._v(" "), _c('v-waypoint', {
    on: {
      "waypoint-in": function($event) {
        _vm.$store.dispatch('updateSticky')
      },
      "waypoint-out": function($event) {
        _vm.$store.dispatch('updateSticky')
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Companies we work with")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/baocheng.jpg"),
      "alt": "ihd baocheng"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/bea.jpg"),
      "alt": "ihd bea"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/hsbc.jpg"),
      "alt": "ihd hsbc"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/jpmorgan.jpg"),
      "alt": "ihd jpmorgan"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/pwc.jpg"),
      "alt": "ihd pwc"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/zhongxin.jpg"),
      "alt": "ihd zhongxin"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7db7f468"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Companies.vue
// module id = 106
// module chunks = 0